import React, { Suspense, useEffect, useRef, useState } from 'react';

const LazySection = ({ children, className = '', animation = 'fade-up', rootMargin = '180px 0px' }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node || isVisible) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold: 0.08 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [isVisible, rootMargin]);

  return (
    <div
      ref={sectionRef}
      className={`lazy-home-section lazy-home-section--${animation} ${isVisible ? 'is-visible' : ''} ${className}`}
    >
      {isVisible ? (
        <Suspense fallback={<div className="lazy-home-section__placeholder" />}>
          {children}
        </Suspense>
      ) : (
        <div className="lazy-home-section__placeholder" />
      )}
    </div>
  );
};

export default LazySection;
